import React from "react";
import { Box, Button } from "@mui/material";

export default function ActionButtonRow(props) {
  return (
    <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
      {props.buttons.map((btn, idx) => (
        <Button
          key={idx}
          variant="outlined"
          size="small"
          color={btn.color || "primary"}
          onClick={btn.onClick}
        >
          {btn.label}
        </Button>
      ))}
    </Box>
  );
}
